import React from 'react';

export const MachineStatusChartTitle = ({
  activeMonth,
  onClick,
}: {
  activeMonth: string | null;
  onClick: () => void;
}) => {
  const hoverStyle = activeMonth
    ? {
        cursor: 'pointer',
        textDecoration: 'underline',
      }
    : undefined;

  return (
    <div className={`font-semibold text-sm py-1 ${activeMonth ? 'cursor-pointer hover:underline' : ''}`} onClick={onClick}>
      {activeMonth ? 'Daily overview of site health' : 'Monthly overview of site health'}
    </div>
  );
};
